import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { Button, HomeLayout, Input } from '../../components'

import './Register.scss'
import { login } from '../../store/user'
import { isDesktop } from '../../utils'
import clsx from 'clsx'

const Register = () => {
   const history = useHistory()
   const dispatch = useDispatch()
   const { isAuthenticated } = useSelector(state => state.user)
   const { isDarkTheme } = useSelector(state => state.theme)

   React.useEffect(() => {
      if (isAuthenticated) {
         history.push('/download-key')
      }
   }, [isAuthenticated, history])

   const [password, setPassword] = React.useState('')
   const [confirmPassword, setConfirmPassword] = React.useState('')

   const handleSubmit = e => {
      e.preventDefault()
      if (password !== '' && password === confirmPassword) {
         axios
            .post(`${process.env.REACT_APP_API_URL}/api/auth/createAccount`, {
               password: password,
            })
            .then(function (response) {
               dispatch(
                  login({
                     privateKeyEncrypted:
                        response.data.identity.privateKeyEncrypted,
                     privateKey: response.data.identity.privateKey,
                     publicKey: response.data.identity.publicKey,
                  })
               )
            })
            .catch(function (error) {
               console.log(error)
            })
      }
   }

   if (isDesktop()) {
      return (
         <HomeLayout>
            <div
               className={clsx(
                  'DesktopRegister',
                  isDarkTheme && 'DesktopRegister--dark'
               )}
            >
               <div className="DesktopRegister__card">
                  <h2 className="DesktopRegister__heading">
                     Set an account password
                  </h2>
                  <p className="DesktopRegister__paragraph">
                     The password you enter encrypts your private key and
                     provides access to your funds. Please store your password
                     safely.
                  </p>
                  <p className="DesktopRegister__paragraph">
                     For security reasons WSNS does not store your password or
                     is able to restore it. Your password cannot be changed.
                  </p>
                  <form
                     className="DesktopRegister__form"
                     onSubmit={handleSubmit}
                  >
                     <Input
                        className="DesktopRegister__form-input"
                        placeholder="Password"
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value.trim())}
                        isDarkTheme={isDarkTheme}
                     />
                     <Input
                        className="DesktopRegister__form-input"
                        placeholder="Confirm Password"
                        type="password"
                        value={confirmPassword}
                        onChange={e =>
                           setConfirmPassword(e.target.value.trim())
                        }
                        isDarkTheme={isDarkTheme}
                     />
                     <Button
                        className="DesktopRegister__form-cta"
                        variant="solid"
                        color="primary"
                        type="submit"
                        size="lg"
                        isDarkTheme={isDarkTheme}
                     >
                        I wrote it down
                     </Button>
                  </form>
               </div>
            </div>
         </HomeLayout>
      )
   }

   return (
      <HomeLayout>
         <main className={clsx('Register', isDarkTheme && 'Register--dark')}>
            <h2 className="Register__heading">Set an account password</h2>
            <p className="Register__paragraph">
               The password you enter encrypts your private key and provides
               access to your funds. Please store your password safely.
            </p>
            <p className="Register__paragraph">
               For security reasons WSNS does not store your password or is able
               to restore it. Your password cannot be changed.
            </p>
            <form className="Register__form" onSubmit={handleSubmit}>
               <Input
                  className="Register__form-input"
                  placeholder="Password"
                  type="password"
                  value={password}
                  isDarkTheme={isDarkTheme}
                  onChange={e => setPassword(e.target.value.trim())}
               />
               <Input
                  className="Register__form-input"
                  placeholder="Confirm Password"
                  type="password"
                  value={confirmPassword}
                  isDarkTheme={isDarkTheme}
                  onChange={e => setConfirmPassword(e.target.value.trim())}
               />
               <Button
                  className="Register__form-cta"
                  variant="solid"
                  color="primary"
                  type="submit"
                  isDarkTheme={isDarkTheme}
               >
                  I wrote it down
               </Button>
            </form>
         </main>
      </HomeLayout>
   )
}

export default Register
